/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const FETCH_TOUR_RATINGS = 'FETCH_TOUR_RATINGS';
export const FETCH_TOUR_RATINGS_SUCCESS = 'FETCH_TOUR_RATINGS_SUCCESS';
export const FETCH_TOUR_RATINGS_ERROR = 'FETCH_TOUR_RATINGS_ERROR';
export const SET_FETCH_TOUR_RATINGS_STATUS = 'SET_FETCH_TOUR_RATINGS_STATUS';

export function fetchTourRatingsByFacilitySuccess(data) {
    return {
        type: FETCH_TOUR_RATINGS_SUCCESS,
        payload: data,
    };
}

export function fetchTourRatingsByFacilityError(error) {
    return {
        type: FETCH_TOUR_RATINGS_ERROR,
        payload: error,
    };
}

export function setFetchTourRatingsByFacilityStatus(status) {
    return {
        type: SET_FETCH_TOUR_RATINGS_STATUS,
        payload: status,
    };
}

export function fetchTourRatingsByFacility({ facilityId, tourIds }) {
    return {
        type: FETCH_TOUR_RATINGS,
        payload: { facilityId, tourIds },
    };
}
